<div class="cobranding-banner" *ngIf="isCobranded" [ngStyle]="{ 'background-color': agencyColor }">
  <div class="cobranding-container container">
    <img class="logo" [src]="agencyLogo">
    <p class="text-center m-0 d-block">{{ agencyName }}</p>
  </div>
</div> 